














































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { PortfolioModel } from '../models/portfolio-model'
import { shortenString } from '@/shared/utils/shorten-string'
import RespondecoResponsiveImage from '@/shared/components/respondeco-responsive-image.vue'
@Component({
  components: { RespondecoResponsiveImage },
})
export default class RespondecoPortfolioItem extends Vue {
  @Prop({
    type: Object,
  })
  public readonly item!: PortfolioModel

  public shortenString = shortenString
}
